// Movies card game data with rankings by cultural impact and popularity
export const MOVIES_CARDS = [
  { id: 1, name: "The Shawshank Redemption", rank: 1, image: "/images/movies/movies_1.jpg" },
  { id: 2, name: "The Godfather", rank: 2, image: "/images/movies/movies_2.jpg" },
  { id: 3, name: "Titanic", rank: 3, image: "/images/movies/movies_3.jpg" },
  { id: 4, name: "Star Wars", rank: 4, image: "/images/movies/movies_4.jpg" },
  { id: 5, name: "The Dark Knight", rank: 5, image: "/images/movies/movies_5.jpg" },
  { id: 6, name: "Jurassic Park", rank: 6, image: "/images/movies/movies_6.jpg" },
  { id: 7, name: "Forrest Gump", rank: 7, image: "/images/movies/movies_7.jpg" },
  { id: 8, name: "The Lion King", rank: 8, image: "/images/movies/movies_8.jpg" },
  { id: 9, name: "Pulp Fiction", rank: 9, image: "/images/movies/movies_9.jpg" },
  { id: 10, name: "Avatar", rank: 10, image: "/images/movies/movies_10.jpg" },
  { id: 11, name: "E.T.", rank: 11, image: "/images/movies/movies_11.jpg" },
  { id: 12, name: "The Matrix", rank: 12, image: "/images/movies/movies_12.jpg" },
  { id: 13, name: "Inception", rank: 13, image: "/images/movies/movies_13.jpg" },
  { id: 14, name: "Gladiator", rank: 14, image: "/images/movies/movies_14.jpg" },
  { id: 15, name: "Back to the Future", rank: 15, image: "/images/movies/movies_15.jpg" },
  { id: 16, name: "Lord of the Rings", rank: 16, image: "/images/movies/movies_16.jpg" },
  { id: 17, name: "Jaws", rank: 17, image: "/images/movies/movies_17.jpg" },
  { id: 18, name: "Schindler's List", rank: 18, image: "/images/movies/movies_18.jpg" },
  { id: 19, name: "Goodfellas", rank: 19, image: "/images/movies/movies_19.jpg" },
  { id: 20, name: "Fight Club", rank: 20, image: "/images/movies/movies_20.jpg" },
  { id: 21, name: "The Avengers", rank: 21, image: "/images/movies/movies_21.jpg" },
  { id: 22, name: "Casablanca", rank: 22, image: "/images/movies/movies_22.jpg" },
  { id: 23, name: "Raiders of the Lost Ark", rank: 23, image: "/images/movies/movies_23.jpg" },
  { id: 24, name: "Silence of the Lambs", rank: 24, image: "/images/movies/movies_24.jpg" },
  { id: 25, name: "Saving Private Ryan", rank: 25, image: "/images/movies/movies_25.jpg" },
  { id: 26, name: "The Wizard of Oz", rank: 26, image: "/images/movies/movies_26.jpg" },
  { id: 27, name: "Toy Story", rank: 27, image: "/images/movies/movies_27.jpg" },
  { id: 28, name: "The Breakfast Club", rank: 28, image: "/images/movies/movies_28.jpg" },
  { id: 29, name: "Rocky", rank: 29, image: "/images/movies/movies_29.jpg" },
  { id: 30, name: "Ghostbusters", rank: 30, image: "/images/movies/movies_30.jpg" }
];
